




































































import Component from 'vue-class-component';
import Vue from 'vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import { VModel } from 'vue-property-decorator';
import TextField from '@/general/component/TextField.vue';
import DatePicker from '@/general/component/form/input/DatePicker.vue';
import SensorAutocomplete from '@/general/component/form/autocomplete/SensorAutcomplete.vue';
import CustomerAutocomplete from '@/general/component/form/autocomplete/CustomerAutocomplete.vue';
import { notNullOrUndefined } from '@/utility/functions';
import { AnomalyRemovalFormModel } from '@/context/calculation/model/AnomalyRemovalFormModel';
import NumberField from '@/general/component/NumberField.vue';

@Component({
  components: {
    SensorAutocomplete,
    CustomerAutocomplete,
    DatePicker,
    FacilityAutocomplete,
    TextInput,
    TextField,
    NumberField
  }
})
export default class AnomalyRemovalFormTemplate extends Vue {
  @VModel({ type: Object }) model!: AnomalyRemovalFormModel;
  valid = true;

  get sensorQP() {
    if (notNullOrUndefined(this.model.customer)) {
      return `client=${this.model.customer}`;
    }
    return "";
  }
  get rules(): Record<string, unknown> {
    return {};
  }
}
